import styled from 'styled-components';
import { Icon } from '../../../../components/common/icon/Icon';

interface ILoginToCheckPriceProps {
  forPreviewCard?: boolean;
  previewCardText?: string;
  defaultText?: string;
  isLockIconShow?: boolean;
}

export const LoginToCheckPrice = ({
  forPreviewCard = false,
  previewCardText = '로그인 후 가격 보기',
  defaultText = '로그인 후 가격 확인',
  isLockIconShow = true,
}: ILoginToCheckPriceProps) => {
  if (forPreviewCard) {
    return <Text>{previewCardText}</Text>;
  }

  return (
    <Container>
      {isLockIconShow && <Icon name={'LockLocked'} size={'Large'} fill={'#FF3049'} />}
      <Text>{defaultText}</Text>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  align-self: stretch;
`;

const Text = styled.span`
  color: var(--Light-Scheme-Color-primary-red, #ff3049);

  /* Display/Large/l-bold */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 20.8px */

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
`;
